import {observer} from "mobx-react"
import {DashboardPage} from "../page"
import {App} from "./App"

const DashboardApp = observer(function OrganizationApp() {
    return <App>
        <DashboardPage />
    </App>
})

export {
    DashboardApp
}
